// extracted by mini-css-extract-plugin
module.exports = {"label":"SeasonalRuleColorPicker_label__3Saya","large":"SeasonalRuleColorPicker_large__1nk9J","colorCircle":"SeasonalRuleColorPicker_colorCircle__3oRcu"};